module.exports = "<template> <sio-time-input config.bind=field value.bind=field.value></sio-time-input> </template> ";